module.exports = __webpack_public_path__ + "img/header-engagementRingsRosegold.e2de980.webp";